import React, { Component } from 'react';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import cjquery from 'jquery';
import StarRatings from 'react-star-ratings';
import { Col, Row, Tooltip } from 'reactstrap';
import language from '../../../../assets/languages/language';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import { getIpAddress } from '../../../../common/getIpAddress';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import FlashCard from '../../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../../common/function';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
import Timer from '../../../../Components-2025/QuestionBank/Timer';
import { messages } from '../../../../common/messages';
import { EXAM_NAMES } from '../../../../common/constant';

/* eslint-disable*/
class Frmchapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      ValidToken: false,
      reportLoading: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      save_text: `${language.LC().SAVE_QUESTION} `,
      savedQuestion: false,
      timerstopbtn: 'pause_btn icon-control-pause',
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      choice_name: '',
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      selectedmenufrm: 'frm',
      display_loader: '',
      selectedmenu: 'frm',
      selectedmenu_2: 'frm_2',
      selectedmenu_1_2: 'frm_1_2',
      subscriptionstatus: '',
      level: '',
      chapter_name: '',

      all_questions: '',
      category: this.props.params.level === '1' ? 'FRM Part 1' : 'FRM Part 2',
      tags: ['frm-2', 'frm-1', 'frm', 'question'],
      title: '',
      description: '',
      forumComment: '',
      isFlashCardHidden: true,
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      timerValue: 0,
      isLoading: true,
      currentIndex: 0,
      showAnswer: false,
      stopTimer: false,
      selectedChoice: '',
      isUserSubscribed: false,
      currentQuestion: {},
      showReportSection: false,
      questionData: [],
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };

    this.getAnswer = this.getAnswer.bind(this);
    this.tick = this.tick.bind(this);
    this.timerFunct = this.timerFunct.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  tick() {
    if (!this.state.timer_stop) {
      this.setState((prevState) => ({ count: prevState.count + 1 }));
    }
  }

  initializeTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(this.tick, 1000);
    this.setState({ timer_stop: false, timerstopbtn: 'pause_btn icon-control-pause' });
  }

  async componentDidMount() {
    window.scrollTo(0, 0);

    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }

    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }

    this.setState({ level: this.props.params.level });

    const user_data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };

    FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, user_data).then(async (resp) => {
      const level_store = this.props.params.level;

      const afterRunCode = () => {
        const questions = this.state.questions;

        if (questions && questions.right_choice) {
          const choiceMap = {
            choice_a: 'A',
            choice_b: 'B',
            choice_c: 'C',
            choice_d: 'D',
          };

          const choice_name = choiceMap[questions.right_choice] || '';
          this.setState({ choice_name });
        }
      };

      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' }, afterRunCode);
        } else {
          const data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          const result = await this._getExamsByUser(data_arr);
          if (result && result.examData) {
            // #261 — pass examPlanData so the partner check's mock-package
            // early-return fires (was missing — partner with mock-only plan
            // saw the QB chapter as "paid" with full access).
            const examPlanData = result.examPlan && result.examPlan[0];
            const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
              level_store,
              result.examData,
              examPlanData,
            );
            if (subscriptionStatus) {
              this._runCode('paid');
              this.setState({ subscriptionstatus: 'paid' }, afterRunCode);
            } else {
              this._runCode('free');
              this.setState({ subscriptionstatus: 'free' }, afterRunCode);
            }
          }
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' }, afterRunCode);
        } else {
          const data_arr = JSON.parse(resp.profileInfo.exam_selected);
          const result = await this._getExamsByUser(data_arr);
          if (result && result.examData) {
            const subscriptionStatus = FrmSubscriptionCheck.checkFrm(level_store, result.examData);
            if (subscriptionStatus) {
              this._runCode('paid');
              this.setState({ subscriptionstatus: 'paid' }, afterRunCode);
            } else {
              this._runCode('free');
              this.setState({ subscriptionstatus: 'free' }, afterRunCode);
            }
          }
        }
      }
    });

    this.initializeTimer();
  }

  async _getExamsByUser(examIds) {
    if (!examIds) return null;

    try {
      const dataset = {
        token: this.state.token,
        idname: this.state.idname,
        examid: examIds,
      };

      const response = await FD.callAPI(
        `${App_data.backend_api}/checkout_v1/getExamsbyUser`,
        dataset,
      );
      if (response.success) {
        // #261 — return BOTH examData and examPlan; callers need
        // examPlan[0] for the partner check's mock-package early-return.
        return { examData: response.examData, examPlan: response.examPlan };
      }
      return null;
    } catch (error) {
      console.error('Error fetching exam data:', error);
      return null;
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  getSelectedAndShowAnswer(currentQuestion, correctChoiceKey = 'right_choice') {
    const selectedChoice =
      currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]
        ? currentQuestion.frm_question_stats[0].selected_choice || ''
        : currentQuestion.selectedChoice || '';
    const rightAnswer =
      currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]
        ? currentQuestion.frm_question_stats[0].right_answer || ''
        : '';
    const answerStatus =
      currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]
        ? currentQuestion.frm_question_stats[0].id || ''
        : '';
    const timeDone =
      currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]
        ? parseInt(currentQuestion.frm_question_stats[0].time_done || 0, 10)
        : 0;
    let showAnswer = false;
    let selected = '';
    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.FRM);

    if (selectedChoice && isRevisionMode) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionMode) {
      if (rightAnswer === 1) {
        selected = currentQuestion[correctChoiceKey];
        showAnswer = true;
      } else if (!rightAnswer) {
        const correct = currentQuestion[correctChoiceKey];
        const choices = Object.keys(currentQuestion).filter(
          (key) => key.startsWith('choice') && key !== correct,
        );
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }
    return { selected, showAnswer, timeDone, isRevisionMode };
  }

  _getReadings = () => {
    this.context.router.push({
      pathname: `/frm/readings/${this.props.params.notesid}/${this.state.selectedmenufrm}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: this.props.params.notesid,
        selectedMenu: this.state.selectedmenufrm,
      },
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: `/frm/questions/${this.props.params.readingid}/${this.props.params.notesid}/${
        this.state.chapter_name
      }/${this.state.subscriptionstatus}/${this.props.params.notesid}/${this.props.params.level}/${
        this.state.selectedmenufrm
      }`,
    });
  };

  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  getPrevious = async () => {
    this.setState({ successAlert: false, report_block: 'card hide_block' });
    const { offset, all_questions_state, token, idname, selectedmenufrm } = this.state;
    const { notesid, readingid, level } = this.props.params;
    const prevIndex = offset - 1;
    if (prevIndex < 0) return;
    const prevQuestion = all_questions_state[prevIndex];
    const { selected, showAnswer, timeDone, isRevisionMode } = this.getSelectedAndShowAnswer(
      prevQuestion,
      'right_choice',
    );
    this.setState({
      offset: prevIndex,
      questions: prevQuestion,
      choice: selected,
      clicked: showAnswer,
      result_block: showAnswer ? 'card show_block' : 'card hide_block',
      text_color:
        selected === prevQuestion.right_choice
          ? 'card-header text_success'
          : 'card-header text_failure',
      result: selected === prevQuestion.right_choice ? messages.CORRECT : messages.INCORRECT,
      display_loader: 'hide_block',
      stopTimer: !!selected,
      timerValue: isRevisionMode ? timeDone : 0,
      previ_block: prevIndex === 0 ? 'card hide_block' : '',
      next_block: '',
    });
    this.context.router.push({
      pathname: `/frm/chapter/${notesid}/${readingid}/${prevQuestion.id}/${level}/${prevIndex}`,
      state: {
        token,
        idname,
        reading: readingid,
        chapter: notesid,
        offset: prevIndex,
        selectedMenu: selectedmenufrm,
      },
    });
  };

  /*
  ---------------------------------------
    Function to fetch Next question
  --------------------------------------
  */
  getNext = async () => {
    this.setState({ successAlert: false, report_block: 'card hide_block' });
    const { offset, all_questions_state, question_length, token, idname, selectedmenufrm } =
      this.state;
    const { notesid, readingid, level } = this.props.params;
    const nextIndex = offset + 1;
    if (nextIndex >= question_length) return;
    const nextQuestion = all_questions_state[nextIndex];
    const { selected, showAnswer, timeDone, isRevisionMode } = this.getSelectedAndShowAnswer(
      nextQuestion,
      'right_choice',
    );
    this.setState({
      offset: nextIndex,
      questions: nextQuestion,
      choice: selected,
      clicked: showAnswer,
      result_block: showAnswer ? 'card show_block' : 'card hide_block',
      text_color:
        selected === nextQuestion.right_choice
          ? 'card-header text_success'
          : 'card-header text_failure',
      result: selected === nextQuestion.right_choice ? messages.CORRECT : messages.INCORRECT,
      display_loader: 'hide_block',
      stopTimer: !!selected,
      timerValue: isRevisionMode ? timeDone : 0,
      next_block: nextIndex === question_length - 1 ? 'card hide_block' : '',
      previ_block: '',
    });
    this.context.router.push({
      pathname: `/frm/chapter/${notesid}/${readingid}/${nextQuestion.id}/${level}/${nextIndex}`,
      state: {
        token,
        idname,
        reading: readingid,
        chapter: notesid,
        offset: nextIndex,
        selectedMenu: selectedmenufrm,
      },
    });
  };

  /*
  --------------------------------------------------------------------------
    Function to check Right Or Wrong Answered and displayed clicked box
  --------------------------------------------------------------------------
  */
  getAnswer = (choice) => {
    const { clicked } = this.state;
    if (clicked) return;

    const selectedChoice = choice[0];
    const choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
    const updatedState = {
      choice: selectedChoice,
      selectedChoice,
      stopTimer: false,
    };

    choices.forEach((key) => {
      updatedState[key] = key === selectedChoice ? 'answer_box selected' : 'answer_box';
    });

    this.setState(updatedState);
  };

  /*
  --------------------------------
    Function to show Report box
  --------------------------------
  */
  _displayReportForm = () => {
    this.setState({ report_block: 'card show_block', successAlert: false });
  };

  /*
  -------------------------------
    Function to hide Report box
  -------------------------------
  */
  _hideReportForm = () => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
  };

  /*
  ---------------------------------------------------------------------------------
      Function to show Correct box and display right answer and store in database
  ---------------------------------------------------------------------------------
  */
  _getResult = () => {
    const { choice, questions, all_questions_state, offset, timerValue, level, token, idname } =
      this.state;
    if (!choice) return;
    const isCorrect = choice === questions.right_choice;
    const updatedQuestion = { ...questions, selectedChoice: choice };
    const updatedQuestionsState = [...all_questions_state];
    updatedQuestionsState[offset] = updatedQuestion;
    this.setState({
      clicked: true,
      text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
      result: isCorrect ? messages.CORRECT : messages.INCORRECT,
      result_block: 'card show_block',
      questions: updatedQuestion,
      all_questions_state: updatedQuestionsState,
      stopTimer: true,
      showAnswer: true,
    });
    const statsData = {
      token,
      idname,
      question_id: questions.id,
      right_answer: isCorrect ? 1 : 0,
      time_done: timerValue,
      level,
      selectedChoice: choice,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveStats`, statsData)
      .then((resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true, validated: true });
        } else {
          this.setState({ ValidToken: false });
        }
      })
      .catch(() => {
        this.setState({ ValidToken: false });
      });
  };

  /*
 -------------------------------------------------------------------- 
  Function to Display Saved Question on button and save in database
 ---------------------------------------------------------------------
*/
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      level: this.state.level,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/unsaveQuestion`, data).then((resp) => {
        if (resp.success) {
          if (this.childRef) {
            this.childRef.deleteFlash();
          }
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION} `,
            isFlashCardHidden: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveQuestion`, data).then((resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
            isFlashCardHidden: false,
          });
          this.getToggleFlash();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  /*
  -------------------------------------------------------------------
     Function to Save flash Card And display new stored flash card
  -------------------------------------------------------------------
  */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }
    const flash_card = document.getElementById('flash_card').value;
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card,
      level: this.state.level,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: ques_res.id,
        };
        FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFlashCards`, params).then(
          (response) => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 hide_block' });
                const flash_cards = response.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
                this.setState({ flash_data: flash_cards });
              } else {
                this.setState({
                  flash_form: 'col-sm-12 display_block',
                  flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p>,
                });
              }
            } else {
              this.setState({
                flash_form: 'col-sm-12 display_block',
                flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p>,
              });
            }
          },
        );
      }
    });
  };

  /*
  -----------------------------------------
    Funcion to save new report question
  -----------------------------------------
 */
  _reportQuestion = () => {
    const {
      questions,
      token,
      idname,
      user_city,
      user_country,
      user_state,
      user_continent,
      user_ip,
    } = this.state;
    const comment = document.getElementById('comment').value;

    if (comment.length < 2) {
      return;
    }

    const data = {
      token,
      idname,
      question_id: questions.id,
      comment,
      city: user_city,
      country: user_country,
      state: user_state,
      continent: user_continent,
      ip: user_ip,
      frmLevel: this.props.params.level,
    };

    this.setState({ reportLoading: true });

    FD.callAPI(`${App_data.backend_api}/frm_question_bank/reportQuestion`, data)
      .then((resp) => {
        if (resp.success) {
          this.setState({
            successAlert: true,
            reportLoading: false,
            report_block: 'card show_block',
          });
          document.getElementById('comment').value = '';
        } else {
          this.setState({ reportLoading: false });
        }
      })
      .catch((error) => {
        this.setState({ reportLoading: false });
      });
  };

  onStarClick(item, nextValue, prevValue, name) {
    const { token, idname } = this.state;
    if (prevValue !== nextValue) {
      const updateParams = {
        token,
        idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/UpdateFrmratting`, updateParams).then(
        (response) => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }
    this.setState({ rating: nextValue });
    const getParams = {
      token,
      question_id: item.id,
      idname,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFrmratting`, getParams).then(
      (response) => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.forEach((ratingItem) => {
              this.setState({ rating: ratingItem.ratting, ratting_text: 'Rated ' });
            });
          } else {
            const saveParams = {
              token,
              idname,
              question_id: item.id,
              ratting: nextValue,
            };
            FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFrmratting`, saveParams).then(
              (saveResp) => {
                if (saveResp.success) {
                  this.setState({
                    rated: 1,
                    ratting_text: `Rated ${nextValue} stars`,
                  });
                }
              },
            );
          }
        } else {
          const saveParams = {
            token,
            idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveFrmratting`, saveParams).then(
            (saveResp) => {
              if (saveResp.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `Rated ${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  _runCode(subscriptionstatus) {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: this.props.params.readingid,
      chapter_id: this.props.params.notesid,
      offset: this.state.offset,
      subscriptionstatus: subscriptionstatus,
      level: this.state.level,
    };

    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestions_allcr`, data).then(
      (resp) => {
        if (resp.success) {
          const allQuestions = resp.questions.map((question) => {
            const selectedChoice =
              question.frm_question_stats && question.frm_question_stats.length > 0
                ? question.frm_question_stats[0].selected_choice
                : '';
            return { ...question, selectedChoice };
          });

          this.setState({
            ValidToken: true,
            all_questions_state: allQuestions,
            question_length: allQuestions.length,
          });

          let offset = 0;
          if (this.props.params.offset !== undefined) {
            offset = parseInt(this.props.params.offset, 10);
            if (isNaN(offset) || offset < 0 || offset >= allQuestions.length) {
              offset = 0;
            }
          }
          const currentQuestion =
            allQuestions[
              offset || allQuestions.findIndex((item) => item.id == this.props.params.id)
            ];
          const { selected, showAnswer, timeDone, isRevisionMode } = this.getSelectedAndShowAnswer(
            currentQuestion,
            'right_choice',
          );

          this.setState(
            {
              questions: currentQuestion,
              offset: offset,
              choice: selected,
              clicked: showAnswer,
              result_block: showAnswer ? 'card show_block' : 'card hide_block',
              text_color:
                selected === currentQuestion.right_choice
                  ? 'card-header text_success'
                  : 'card-header text_failure',
              result:
                selected === currentQuestion.right_choice ? messages.CORRECT : messages.INCORRECT,
              display_loader: 'hide_block',
              stopTimer: !!selected,
              timerValue: isRevisionMode ? timeDone : 0,
            },
            () => {
              const rightChoice = this.state.questions.right_choice;
              const choiceMap = {
                choice_a: 'A',
                choice_b: 'B',
                choice_c: 'C',
                choice_d: 'D',
              };

              if (choiceMap[rightChoice]) {
                this.setState({ choice_name: choiceMap[rightChoice] });
              }
            },
          );

          if (offset === 0) {
            this.setState({ previ_block: 'card hide_block' });
          }
          if (offset === allQuestions.length - 1) {
            this.setState({ next_block: 'card hide_block' });
          }

          FD.callAPI(`${App_data.backend_api}/frm_question_bank/getChapterbyID`, {
            token: this.state.token,
            chapter_id: this.props.params.notesid,
          }).then((resp_chap) => {
            if (resp_chap.success && resp_chap.chapters && resp_chap.chapters.length > 0) {
              this.setState({ chapter_name: resp_chap.chapters[0].chapter_name });
            }
          });

          FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFavQuestions`, {
            token: this.state.token,
            question_id: currentQuestion.id,
            idname: this.state.idname,
          }).then((response) => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                bookmarkColor: 'rgb(54, 141, 84)',
                save_text: `${language.LC().Question_Saved}`,
                isFlashCardHidden: false,
              });
            } else {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
                bookmarkColor: '',
                save_text: `${language.LC().SAVE_QUESTION} `,
                isFlashCardHidden: true,
              });
            }
          });

          this.fetchRatingForCurrentQuestion(currentQuestion.id);
        } else {
          this.setState({ ValidToken: false, records: 'Result not found.' });
        }
      },
    );
  }

  /*
  ----------------------------------------
    on url change run this function
  ---------------------------------------
  */
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this._changeContent(
        nextProps.params.id,
        nextProps.params.notesid,
        nextProps.params.readingid,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }
  /*on url change run this function*/
  _changeContent(qui_id, chapter_id, readingid, token_id, idname, offset_val) {
    const { subscriptionstatus, level, token, idname: stateIdname } = this.state;
    var data = {
      token: token_id,
      idname: idname,
      reading_id: readingid,
      chapter_id: chapter_id,
      offset: offset_val,
      subscriptionstatus,
      level,
    };

    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getQuestions_allcr`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            choice_a: 'answer_box',
            choice_b: 'answer_box',
            choice_c: 'answer_box',
            choice_d: 'answer_box',
            result_block: 'card hide_block',
          });

          let foundIndex = parseInt(offset_val, 10);
          if (isNaN(foundIndex) || foundIndex < 0 || foundIndex >= resp.questions.length) {
            foundIndex = 0;
          }
          let ques_res = resp.questions[foundIndex];

          this.setState({ questions: ques_res, offset: foundIndex }, () => {
            const choiceMap = {
              choice_a: 'A',
              choice_b: 'B',
              choice_c: 'C',
              choice_d: 'D',
            };

            const rightChoice = this.state.questions.right_choice;
            const choiceName = choiceMap[rightChoice] || '';

            this.setState({ choice_name: choiceName });

            const { selected, showAnswer, timeDone, isRevisionMode } =
              this.getSelectedAndShowAnswer(this.state.questions, 'right_choice');
            this.setState({
              choice: selected,
              clicked: showAnswer,
              result_block: showAnswer ? 'card show_block' : 'card hide_block',
              text_color:
                selected === this.state.questions.right_choice
                  ? 'card-header text_success'
                  : 'card-header text_failure',
              result:
                selected === this.state.questions.right_choice
                  ? messages.CORRECT
                  : messages.INCORRECT,
              display_loader: 'hide_block',
              timer_stop: !!selected,
              timerstopbtn: !!selected
                ? 'pause_btn icon-control-play'
                : 'pause_btn icon-control-pause',
              timerValue: isRevisionMode ? timeDone : 0,
            });

            this.fetchRatingForCurrentQuestion(ques_res.id);
          });
          var params = {
            token: this.state.token,
            question_id: ques_res.id,
            idname: this.state.idname,
          };
          FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFavQuestions`, params).then(
            (response) => {
              if (response.success) {
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                  bookmarkColor: 'rgb(54, 141, 84)',
                  save_text: `${language.LC().Question_Saved}`,
                  isFlashCardHidden: false,
                });
              } else {
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
                  bookmarkColor: '',
                  save_text: `${language.LC().SAVE_QUESTION} `,
                  isFlashCardHidden: true,
                });
              }
            },
          );

          var params = {
            token: this.state.token,
            question_id: ques_res.id,
            idname: this.state.idname,
          };
          FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFrmratting`, params).then(
            (response) => {
              if (response.success) {
                this.setState({ rated: true });
                response.ratting.map((items) => {
                  this.setState({ rating: items.ratting, ratting_text: 'Rated ' });
                });
              }
            },
          );

          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: ques_res.id,
          };

          FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFlashCards`, params).then(
            (response) => {
              if (response.success) {
                this.setState({ ValidToken: true });
                if (response.flash_cards.length > 0) {
                  this.setState({ flash_form: 'col-sm-12 hide_block' });
                  var flash_cards = response.flash_cards.map((items, index) => (
                    <li key={index}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({ flash_form: 'col-sm-12 display_block' });
                  var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards });
              } else {
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({
                  ValidToken: false,
                  flash_data: flash_cards,
                  flash_form: 'col-sm-12 display_block',
                });
              }
              return response;
            },
          );
          this.setState({ records: '' });

          this.fetchRatingForCurrentQuestion(ques_res.id);
        } else {
          this.setState({ ValidToken: false, records: 'Result not found.' });
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
        return resp;
      },
    );
    this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  /*
  ----------------------------------
    Function to start or stop timer
  ----------------------------------
  */
  timerFunct() {
    if (this.state.timer_stop) {
      this.initializeTimer();
    } else {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.setState({
        timer_stop: true,
        timerstopbtn: 'pause_btn icon-control-play',
      });
    }
  }

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  getTimerValue = (value) => {
    this.setState({ timerValue: value });
  };

  updateState = (updates) => {
    this.setState((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  async componentDidUpdate(prevProps) {
    const { id } = this.props.params;
    const { questionData } = this.state;
    const prevId = prevProps.params.id;

    if (id !== prevId && questionData.length > 0) {
      await this.initializeQuestionState(questionData);
    }
  }

  fetchQuestions = async () => {
    const { readingid } = this.props.params;
    const { token, idname, level } = this.state;
    try {
      const response = await FD.callAPI(
        `${App_data.backend_api}/frm_question_bank/getQuestions_allcr`,
        {
          token,
          idname,
          readingid,
          level,
        },
      );

      if (response && response.success) {
        const questions = response.questions;
        await this.initializeQuestionState(questions);
        this.updateState({
          questionData: questions,
          isLoading: false,
        });
      }
    } catch (error) {
      this.updateState({ isLoading: false });
    }
  };

  initializeQuestionState = async (questionsData) => {
    this.setState({ isLoading: true });
    const { id } = this.props.params;

    const index =
      id && id !== ':id' ? questionsData.findIndex((item) => String(item.id) === String(id)) : 0;

    const currentQuestion = questionsData[Math.max(0, index)];
    if (!currentQuestion) {
      this.setState({ isLoading: false });
      return;
    }

    const { selectedChoice, showAnswer, stopTimer, timeDone } =
      this.determineAnswerState(currentQuestion);

    this.setState({
      selectedChoice,
      stopTimer,
      showAnswer,
      currentIndex: Math.max(0, index),
      currentQuestion,
      timerValue: timeDone,
      isLoading: false,
    });
  };

  determineAnswerState = (question) => {
    const selectedChoice =
      question.frm_question_stats && question.frm_question_stats[0]
        ? question.frm_question_stats[0].selected_choice || ''
        : '';
    const rightAnswer =
      question.frm_question_stats && question.frm_question_stats[0]
        ? question.frm_question_stats[0].right_answer || ''
        : '';
    const answerStatus =
      question.frm_question_stats && question.frm_question_stats[0]
        ? question.frm_question_stats[0].id || ''
        : '';
    const timeDone =
      question.frm_question_stats && question.frm_question_stats[0]
        ? parseInt(question.frm_question_stats[0].time_done || 0, 10)
        : 0;

    let showAnswer = false;
    let selected = '';

    if (selectedChoice) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus) {
      if (rightAnswer === 1) {
        selected = question.right_choice;
        showAnswer = true;
      } else if (!rightAnswer) {
        const correct = question.right_choice;
        const choices = Object.keys(question).filter(
          (key) => key.startsWith('choice') && key !== correct,
        );
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }

    return {
      selectedChoice: selected,
      showAnswer,
      stopTimer: !!selected,
      timeDone,
    };
  };

  navigateToQuestion = (newIndex) => {
    const { questionData } = this.state;
    const { readingid } = this.props.params;
    const { router } = this.context;

    const questionId = questionData[newIndex] && questionData[newIndex].id;
    if (questionId) {
      router.push({
        pathname: `/frm/questions/${readingid}/${questionId}/${this.state.level}`,
      });
    }
  };

  getPreviousQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex > 0) {
      await this.initializeQuestionState(questionData);
      this.navigateToQuestion(currentIndex - 1);
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex < questionData.length - 1) {
      await this.initializeQuestionState(questionData);
      this.navigateToQuestion(currentIndex + 1);
    }
  };

  validateQuestion = async () => {
    const { selectedChoice, questionData, currentIndex, timerValue, token, idname, level } =
      this.state;
    if (!selectedChoice) return;

    const currentQuestion = questionData[currentIndex];
    const isCorrect = currentQuestion && currentQuestion.right_choice === selectedChoice;

    try {
      const data = {
        token,
        idname,
        question_id: currentQuestion && currentQuestion.id,
        right_answer: isCorrect ? 1 : 0,
        time_done: timerValue,
        level,
        selectedChoice,
      };
      const result = await FD.callAPI(`${App_data.backend_api}/frm_question_bank/saveStats`, data);

      if (result && result.success) {
        const updatedQuestionData = [...questionData];
        let statsId = '';
        if (currentQuestion.frm_question_stats && currentQuestion.frm_question_stats[0]) {
          statsId = currentQuestion.frm_question_stats[0].id;
        }

        updatedQuestionData[currentIndex] = {
          ...currentQuestion,
          frm_question_stats: [
            {
              selected_choice: selectedChoice,
              time_done: timerValue,
              answer_status: result.answer_status || 0,
              id: result.id || statsId,
              right_answer: isCorrect ? 1 : 0,
            },
          ],
        };

        this.setState({
          stopTimer: true,
          showAnswer: true,
          questionData: updatedQuestionData,
          currentQuestion: updatedQuestionData[currentIndex],
        });
      }
    } catch (error) {}
  };

  setAnswer = (answer) => {
    this.updateState({ selectedChoice: answer[0] });
  };

  onSaveItemChange = (status) => {
    this.updateState({ isFlashCardHidden: status });
  };

  toggleReportSection = () => {
    this.updateState((prevState) => ({ showReportSection: !prevState.showReportSection }));
  };

  hideReportSection = () => {
    this.updateState({ showReportSection: false });
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  fetchRatingForCurrentQuestion = (questionId) => {
    const { token, idname } = this.state;
    const params = {
      token,
      question_id: questionId,
      idname,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getFrmratting`, params).then(
      (response) => {
        if (response.success && response.ratting.length > 0) {
          const ratingValue = response.ratting[0].ratting;
          this.setState({
            rating: ratingValue,
            rated: true,
            ratting_text: `Rated ${ratingValue} stars`,
          });
        } else {
          this.setState({
            rating: 0,
            rated: false,
            ratting_text: language.LC().RATE_THIS_QUESTION,
          });
        }
      },
    );
  };

  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      showAnswer,
      selectedChoice,
      isFlashCardHidden,
      stopTimer,
      showReportSection,
      timerValue,
      questions,
      clicked,
      choice,
    } = this.state;

    let timeDone = 0;
    if (questions && questions.frm_question_stats && questions.frm_question_stats[0]) {
      timeDone = parseInt(questions.frm_question_stats[0].time_done || 0, 10);
    }

    let data = '';
    let forumData = '';
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      const temp_min = Math.trunc(count_temp_var / 60);
      const temp_sec = Math.trunc(count_temp_var % 60);
      display_time = `${temp_min}min ${temp_sec}sec`;
    }
    const retun_all_question = JSON.stringify(this.state.questions);
    const selectedQuestion = JSON.parse(retun_all_question);

    if (questionData !== '') {
      forumData = `<div class="col-sm-12 no-cursor">
        <div class="margin_bottom_40">
          <div>
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 cursor-text">
                    <div contentEditable='false' class="margin_bottom_40 view_questionhtml bg_blue">
                      ${selectedQuestion.question}
                    </div>
                  </div>
                  <div class="col-sm-12" id="choice_a">
                    <div class="answer_box_forum">
                      <div class="answer_count">${language.LC().A}</div>
                      <p class="ans_box_text">
                        <span contentEditable='false'>${selectedQuestion.choice_a}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12" id="choice_b">
                    <div class="answer_box_forum">
                      <div class="answer_count">${language.LC().B}</div>
                      <p class="ans_box_text">
                        <span contentEditable='false'>${selectedQuestion.choice_b}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12" id="choice_c">
                    <div class="answer_box_forum">
                      <div class="answer_count">${language.LC().C}</div>
                      <p class="ans_box_text">
                        <span contentEditable='false'>${selectedQuestion.choice_c}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 margin_bottom_30" id="choice_d">
                    <div class="answer_box_forum">
                      <div class="answer_count">${language.LC().D}</div>
                      <p class="ans_box_text">
                        <span contentEditable='false'>${selectedQuestion.choice_d}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 cursor-text">
                    <p contentEditable='false' class='view_questionhtml'>
                      ${language.LC().THE_CORRECT_ANSWER_IS} <b>${this.state.choice_name}</b>
                    </p>
                    <p contentEditable='false' class='view_questionhtml'>${selectedQuestion.answer}</p>
                  </div>
                  <div class="col-sm-12 margin_bottom_30">
                    <div class="userQuestionDiv">
                      <span class="questionColor cursor-text">*User Question:</span>
                      <div class="forum-data-comment cursor-text">
                        <h4>${this.state.forumComment}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

      data = (
        <div className='col-sm-12 col-md-12'>
          <div className='card margin_bottom_40'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                alt=''
                width='30'
              />
              {selectedQuestion.name} ({language.LC().Q} {selectedQuestion.id})
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this.getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this.getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <ViewQuestion
                    {...selectedQuestion}
                    {...this.props}
                    setAnswer={this.getAnswer}
                    showAnswer={clicked}
                    correctChoice={questions.right_choice}
                    selectedChoice={choice}
                  >
                    <Col md={12} className='mt-2'>
                      <Row className='align-items-center'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          clicked={this.state.clicked || !this.state.choice}
                          _getResult={this._getResult}
                          _saveQuestion={() => this._saveQuestion(selectedQuestion)}
                          _displayReportForm={() => this._displayReportForm(selectedQuestion)}
                          all_questions={selectedQuestion}
                          save_text={this.state.save_text}
                          bookmarkCSS={this.state.bookmarkCSS}
                          bookmarkColor={this.state.bookmarkColor}
                          showResult={this.state.clicked || !this.state.choice}
                        />
                        <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                          <div className='star_rating_wrap'>
                            <span className=' margin_bottom_0 margin_right_10'>
                              {this.state.ratting_text}
                            </span>
                            <StarRatings
                              rating={this.state.rating}
                              starRatedColor='rgb(255, 180, 0)'
                              starEmptyColor='rgb(51, 51, 51)'
                              starDimension='20px'
                              starHoverColor='rgb(255, 180, 0)'
                              starSpacing='2px'
                              changeRating={this.onStarClick.bind(this, selectedQuestion)}
                              numberOfStars={5}
                              name='rate1'
                            />
                          </div>
                        </div>
                      </Row>
                    </Col>
                  </ViewQuestion>
                </div>
                <div className='col-sm-3'>
                  <Timer
                    getTimerValue={this.getTimerValue}
                    stopTimer={this.state.stopTimer}
                    shouldFetchFromServer={true}
                    key={questions && questions.id}
                    initialTime={this.state.timerValue}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={`${this.state.result_block} font-lusitana font-16px`}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              <p>
                {language.LC().THE_CORRECT_ANSWER_IS} <strong>{this.state.choice_name}.</strong>
              </p>
              {renderHTMLContent(selectedQuestion.answer, 'div')}
            </div>
          </div>
          <FlashCard
            item={selectedQuestion}
            type='question'
            isFlashCardHidden={this.state.isFlashCardHidden}
            ref={this.setChildRef}
            exam='frm'
            level={this.state.questions.level}
          />
          <div className={this.state.report_block}>
            <div className='card-header'>{language.LC().REPORT}</div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-sm-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class'
                      onClick={this._reportQuestion.bind(this, selectedQuestion)}
                    >
                      {language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, selectedQuestion)}
                    >
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      data = (
        <div className='col-sm-12 col-md-12'>
          <div className='no_data_bar card'>No Records Found</div>
        </div>
      );
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 d-flex justify-content-between'>
            <div>
              <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
            </div>
            <div>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getQuestions}
              >
                {' '}
                {language.LC().CHANGE_QUESTIONS}
              </button>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getReadings}
              >
                {' '}
                {language.LC().CHANGE_READING}
              </button>
            </div>
          </div>
          <div className='row'>{data}</div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

export default Frmchapter;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmQueBank/Frmchapter/Frmchapter.js